document.addEventListener('DOMContentLoaded', () => {
  const personalisedDrawer = document.querySelector('.personalised-drawer');
  const form = document.querySelector('.edit-personalised-label-form');
  const input1 = document.getElementById('line-1');
  const input2 = document.getElementById('line-2');
  const personalisedLabelButton = document.querySelector('#personalised-label-button');
  const removeWrapper = document.querySelector('.edit-personalised-label-form__remove');
  const removeButton = document.querySelector('#edit-personalised-label-form__remove__button');
  const personalisedFormError = document.querySelector('.edit-personalised-label-form__error');
  const personalisedLabelError = document.querySelector('.personalised__error');
  const validationGuideMessage = document.querySelector('.personalised-drawer__validation-message');
  const variantId = document.querySelector('.personalised-drawer').dataset.variantId;
  const characterLimit = 14;

  const validCharacters = /^[A-Z0-9&'!#$%'*+\-\/=?^_`{}~@ ]{0,14}$/i;

  // Function to generate storage key
  function getStorageKey(key) {
    return `${variantId}_${key}`;
  }

  // Retrieve values from local storage and populate the inputs
  input1.value = localStorage.getItem(getStorageKey('line-1')) || '';
  input2.value = localStorage.getItem(getStorageKey('line-2')) || '';

  // Update character counters initially
  updateCharacterCounter(input1, document.querySelector('#line-1-counter'));
  updateCharacterCounter(input2, document.querySelector('#line-2-counter'));

  // Add active classes to button if there are values in local storage for line-1 or line-2
  if (input1.value || input2.value) {
    personalisedLabelButton.classList.add('personalised__button--filled');
    personalisedLabelButton.classList.add('bg-grey-1000');
    personalisedLabelButton.classList.add('text-grey-0');
    personalisedLabelButton.classList.remove('bg-grey-30');
    personalisedLabelButton.classList.remove('text-grey-1000');
    personalisedLabelButton.classList.remove('hover:bg-grey-150');
    removeWrapper.classList.remove('hidden');
    validationGuideMessage.classList.remove('md:mt-spacing-7xl', 'xl:mt-spacing-9xl');
    validationGuideMessage.classList.add('md:mt-spacing-xl', 'xl:mt-spacing-3xl');
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    // Check if at least one input has a value
    const line1 = input1.value.trim().toUpperCase();
    const line2 = input2.value.trim().toUpperCase();

    if (!line1 && !line2) {
      personalisedFormError.textContent = 'Please provide a value for at least one input.';
      personalisedFormError.classList.remove('hidden');
      removeWrapper.classList.add('hidden');
    } else if (!validCharacters.test(line1) || !validCharacters.test(line2)) {
      personalisedFormError.textContent = 'Invalid characters or line length. Please follow the input guidelines.';
      personalisedFormError.classList.remove('hidden');
    } else {
      // Save values to local storage
      localStorage.setItem(getStorageKey('line-1'), line1);
      localStorage.setItem(getStorageKey('line-2'), line2);
      personalisedDrawer.classList.add('translate-x-full', 'opacity-0');
      personalisedLabelError.classList.add('hidden');
      personalisedFormError.classList.add('hidden');
      removeWrapper.classList.remove('hidden');
      personalisedLabelButton.classList.add('personalised__button--filled');
      personalisedLabelButton.classList.remove('hover:bg-grey-150');
      validationGuideMessage.classList.remove('md:mt-spacing-7xl', 'xl:mt-spacing-9xl');
      validationGuideMessage.classList.add('md:mt-spacing-xl', 'xl:mt-spacing-3xl');
    }
  });

  // Save input values to local storage as the user types
  input1.addEventListener('input', () => {
    validateInputs(input1);
    updateCharacterCounter(input1, document.querySelector('#line-1-counter'));
  });

  input2.addEventListener('input', () => {
    validateInputs(input2);
    updateCharacterCounter(input2, document.querySelector('#line-2-counter'));
  });

  // Add event listener for the remove button
  removeButton.addEventListener('click', () => {
    input1.value = '';
    input2.value = '';
    localStorage.removeItem(getStorageKey('line-1'));
    localStorage.removeItem(getStorageKey('line-2'));
    removeWrapper.classList.add('hidden');
    validationGuideMessage.classList.remove('md:mt-spacing-xl', 'xl:mt-spacing-3xl');
    validationGuideMessage.classList.add('md:mt-spacing-7xl', 'xl:mt-spacing-9xl');
    personalisedLabelButton.classList.remove('personalised__button--filled');
    updateCharacterCounter(input1, document.querySelector('#line-1-counter'));
    updateCharacterCounter(input2, document.querySelector('#line-2-counter'));
    validateInputs();
  });

  function validateInputs(input) {
    const line1 = input1.value.trim().toUpperCase();
    const line2 = input2.value.trim().toUpperCase();

    if (!validCharacters.test(line1) || !validCharacters.test(line2)) {
      personalisedFormError.textContent = 'Invalid characters or line length. Please follow the input guidelines.';
      personalisedFormError.classList.remove('hidden');
    } else {
      personalisedFormError.classList.add('hidden');
    }
  }

  function updateCharacterCounter(input, counterElement) {
    const remaining = characterLimit - input.value.length;
    counterElement.textContent = remaining;

    if (remaining < 0) {
      counterElement.classList.remove('text-grey-650');
      counterElement.classList.add('text-brand-red');
    } else {
      counterElement.classList.remove('text-brand-red');
      counterElement.classList.add('text-grey-650');
    }
  }

  function handleEmptyInputs() {
    if (personalisedLabelError || personalisedLabelButton) {
      personalisedLabelError.classList.remove('hidden');
      personalisedLabelButton.classList.remove('border-transparent');
      personalisedLabelButton.classList.add('border-brand-red');
    }
  }

  document.addEventListener('emptyInputs', handleEmptyInputs);
});
